import type { EditorKeyboardShortcut } from '@narrativebench/editor-core';
import { EDITOR_KEYBOARD_SHORTCUTS } from '@narrativebench/editor-core';

const TIPTAP_STATIC_SHORTCUTS: EditorKeyboardShortcut[] = [
  { key: 'Mod-b', descriptionKey: 'shortcut_bold' },
  { key: 'Mod-i', descriptionKey: 'shortcut_italic' },
  { key: 'Mod-u', descriptionKey: 'shortcut_underline' },
  { key: 'Mod-e', descriptionKey: 'shortcut_code' },
  { key: 'Mod-Shift-7', descriptionKey: 'shortcut_ordered_list' },
  { key: 'Mod-Shift-8', descriptionKey: 'shortcut_bullet_list' },
  { key: 'Mod-Shift-9', descriptionKey: 'shortcut_task_list' },
  { key: 'Mod-Shift-b', descriptionKey: 'shortcut_blockquote' },
  { key: 'Mod-Alt-c', descriptionKey: 'shortcut_code_block' },
  { key: 'Mod-Alt-1', descriptionKey: 'shortcut_heading_1' },
  { key: 'Mod-Alt-2', descriptionKey: 'shortcut_heading_2' },
  { key: 'Mod-Alt-3', descriptionKey: 'shortcut_heading_3' },
  { key: 'Mod-Alt-4', descriptionKey: 'shortcut_heading_4' },
  { key: 'Mod-Alt-5', descriptionKey: 'shortcut_heading_5' },
  { key: 'Mod-Alt-6', descriptionKey: 'shortcut_heading_6' },
  { key: 'Mod-f', descriptionKey: 'shortcut_search' },
  { key: 'Escape', descriptionKey: 'shortcut_close_search' },
  { key: 'Escape', descriptionKey: 'shortcut_focus_mode' },
  { key: 'Mod-Alt-s', descriptionKey: 'shortcut_synonyms' },
  { key: 'Mod-Alt-a', descriptionKey: 'shortcut_analyze_selection' },
  { key: 'Mod-Alt-m', descriptionKey: 'shortcut_add_comment' },
  { key: 'Mod-Alt-d', descriptionKey: 'shortcut_document_chat' },
  { key: 'Mod-Alt-f', descriptionKey: 'shortcut_add_footnote' },
  { key: 'Mod-Alt-n', descriptionKey: 'shortcut_move_to_note' },
];

export function getEditorKeyboardShortcuts(): EditorKeyboardShortcut[] {
  const fromCore = EDITOR_KEYBOARD_SHORTCUTS;
  const combined = [...fromCore];
  for (const s of TIPTAP_STATIC_SHORTCUTS) {
    if (!combined.some((c) => c.key === s.key && c.descriptionKey === s.descriptionKey)) {
      combined.push(s);
    }
  }
  return combined;
}

export function formatShortcutKey(key: string): string {
  const isMac = typeof navigator !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
  return key
    .split('-')
    .map((part) => {
      if (part === 'Mod') return isMac ? '⌘' : 'Ctrl';
      if (part === 'Shift') return isMac ? '⇧' : 'Shift';
      if (part === 'Alt') return isMac ? '⌥' : 'Alt';
      return part.length === 1 ? part.toUpperCase() : part;
    })
    .join(isMac ? '' : '+');
}
